import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import FreePreview from "@/pages/FreePreview";
import Method from "@/pages/Method";
import Lead from "@/pages/Lead";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Tools from "@/pages/Tools";
import Downloads from "@/pages/Downloads";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { ToolsAuthProvider } from "@/context/ToolsAuthContext";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 350);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  // Lenis smooth-scroll hijacks native scrolling and is a known cause of frozen/
  // unresponsive pages on iOS Safari. Enable it only on pointer-fine (desktop) devices;
  // touch devices use native scrolling.
  const useSmooth =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(pointer: fine)").matches;

  const tree = (
    <BrowserRouter>
      <ToolsAuthProvider>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/method" element={<Method />} />
          <Route path="/lead" element={<Lead />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<Article />} />
          <Route path="/free-preview" element={<FreePreview />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </ToolsAuthProvider>
    </BrowserRouter>
  );

  return (
    <div className="App">
      {useSmooth ? (
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          {tree}
        </ReactLenis>
      ) : (
        tree
      )}
    </div>
  );
}

export default App;
